// Shared chrome for the "Mi cuenta" area: the page header plus the
// Perfil | Seguridad | Notificaciones tab strip. /account/profile,
// /account/security and /account/notifications each render it so the three routes
// read as one tabbed area; switching tabs navigates between the routes (each owns
// its own data + logic). Notificaciones is per-user preferences and reachable by
// every role — deliberately outside the owner-only Settings area.

import { useNavigate } from 'react-router-dom'

import { PageHeader } from '../../design-system/index.js'

// The account sections live on separate routes, so this is route navigation
// styled as a tab strip — a <nav> with aria-current, NOT the role=tab Tabs
// primitive (whose aria-controls would point at panels that aren't on the page).

export type AccountTab = 'perfil' | 'seguridad' | 'notificaciones'

const ACCOUNT_TABS: { id: AccountTab; label: string; path: string }[] = [
  { id: 'perfil', label: 'Perfil', path: '/account/profile' },
  { id: 'seguridad', label: 'Seguridad', path: '/account/security' },
  { id: 'notificaciones', label: 'Notificaciones', path: '/account/notifications' },
]

export function AccountTabsHeader({ active }: { active: AccountTab }): JSX.Element {
  const navigate = useNavigate()
  return (
    <>
      <PageHeader title="Mi cuenta" subtitle="Tus datos personales y tu seguridad." />
      <nav aria-label="Secciones de mi cuenta" className="mt-4 flex gap-0.5 border-b border-line">
        {ACCOUNT_TABS.map((t) => {
          const isActive = t.id === active
          return (
            <button
              key={t.id}
              type="button"
              aria-current={isActive ? 'page' : undefined}
              onClick={() => {
                if (!isActive) void navigate(t.path)
              }}
              className={`-mb-px border-b-2 px-[13px] py-[11px] text-[12.5px] font-semibold transition-colors focus-visible:rounded-[4px] focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand-blue ${
                isActive
                  ? 'border-brand-blue text-link'
                  : 'border-transparent text-text-2 hover:text-text'
              }`}
            >
              {t.label}
            </button>
          )
        })}
      </nav>
    </>
  )
}
